module.exports = __webpack_public_path__ + "static/media/bootstrap.a5d6df9f.png";